import { Controller } from 'stimulus';
import csrfToken from '../helpers/csrfToken';
import laravelErrorsToListHtml from '../helpers/laravelErrorsToListHtml';

class WorkplaceCalculatorController extends Controller {
  static targets = [
    'submit',
    'errors',
    'result',
    'form',
  ];

  // eslint-disable-next-line class-methods-use-this
  onSubmit(event) {
    event.preventDefault();
  }

  async onValid() {
    this.lockForm();

    const formData = this.formDataFromForm();

    try {
      const res = await this.postFormData(formData);

      if (res.status >= 300) {
        const jsonBody = await res.json();
        const errors = typeof jsonBody.errors !== 'undefined' ? jsonBody.errors : [];

        this.outputErrors(errors);

        this.unlockForm();

        return;
      }

      const data = await res.text();

      this.displayCalculationResult(data);
    } catch (err) {
      this.outputErrors(['Er is iets misgegaan bij het berekenen.']);
      // eslint-disable-next-line no-console
      console.error(err);
    }

    this.unlockForm();
  }

  outputErrors(errors) {
    const errorsHtml = laravelErrorsToListHtml(errors);

    this.errorsTarget.innerHTML = errorsHtml;
    this.errorsTarget.style.display = errorsHtml.length ? 'block' : 'none';
    this.errorsTarget[errorsHtml.length ? 'setAttribute' : 'removeAttribute']('aria-live', 'assertive');
  }

  displayCalculationResult(data) {
    this.resultTarget.innerHTML = data;
    this.resultTarget.style.display = 'block';

    this.formTarget.style.display = 'none';
  }

  previous() {
    this.resultTarget.style.display = 'none';
    this.formTarget.style.display = 'block';
  }

  postFormData(formData) {
    return fetch(this.data.get('api'), {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': csrfToken(),
      },
      body: formData,
      credentials: 'same-origin',
    });
  }

  formDataFromForm() {
    return new FormData(this.element);
  }

  lockForm() {
    this.toggleFormLock(true);
  }

  unlockForm() {
    this.toggleFormLock(false);
  }

  toggleFormLock(state) {
    this.submitTarget[state ? 'setAttribute' : 'removeAttribute']('disabled', 'disabled');
  }
}

export default WorkplaceCalculatorController;
